/**
 * @generated SignedSource<<aec1f4e259b0b0fe3d497f3f1c88a6f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bigReadContentQueue$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"postiesPrimaryContentItemContent">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "bigReadContentQueue";
};
export type bigReadContentQueue$key = {
  readonly " $data"?: bigReadContentQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"bigReadContentQueue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "bigReadContentQueue",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "postiesPrimaryContentItemContent"
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "items(first:2)"
    }
  ],
  "type": "Queue",
  "abstractKey": null
};

(node as any).hash = "871a09b84bb27cf75a703c3df9257958";

export default node;
